import {elementNameConst} from '../../conf';

import iconFont from './node/icon_font';
import customImage from './node/custom_image';

import quadraticCircleRunning from './edge/quadratic_circle_running';
import quadraticDashRunning from './edge/quadratic_dash_running';
import quadraticGrowthRunning from './edge/quadratic_growth_running';
import quadraticLiquidFillRunning from './edge/line_liquid_fill_running';
import cubicCircleRunning from './edge/cubic_circle_running';


/**
 * 拓扑插件-自定义节点、边（边线）等图形
 */
const customShapes = {
  iconFont,
  customImage,

  quadraticCircleRunning,
  quadraticDashRunning,
  quadraticGrowthRunning,
  quadraticLiquidFillRunning,
  cubicCircleRunning
};


export default function(G6) {
  Object.values(customShapes).forEach(item => {
    if (item && item.name && item.options) {
      if (item?.type === elementNameConst.node) {

        G6.registerNode(item.name, item.options, item?.extendedNodeName);

      } else if (item?.type === elementNameConst.edge) {

        G6.registerEdge(item.name, item.options, item?.extendedNodeName);

      } else if (item?.type === elementNameConst.combo) {

        G6.registerCombo(item.name, item.options, item?.extendedNodeName);

      }
    }
  });
}
